<template>
    <Fragment v-if="configuration" :key="'fr_' + randomId">
        <tr :key="'frm_' + randomId">
            <td colspan="4" class="text-left">{{product.name}}</td>
        </tr>
        <tr :key="'srm_' + randomId" style="border-bottom: 1px solid #ccc">
            <td class="text-left">{{product.id}}</td>
            <td class="text-center">
                {{ product.quantity | currency({
                    symbol: "",
                    fractionCount: 0
                })}} {{product.unit_type}}
            </td>
            <td v-show="configuration.priceList.show_prices == 1" class="text-center">
                {{product.price_unit | currency({
                    symbol: configuration.priceList.currency,
                    thousandsSeparator: configuration.priceList.thousands_separator,
                    fractionCount: 2,
                    fractionSeparator: configuration.priceList.decimal_separator,
                    symbolPosition: (configuration.priceList.currency_position == "right" ? "" : "front"),
                    symbolSpacing: true
                })}}/{{ (product.min_quantity > 1) ? product.min_quantity : "" }} {{product.unit_type}}
            </td>
            <td class="text-center">
                {{product.total | currency({
                    symbol: configuration.priceList.currency,
                    thousandsSeparator: configuration.priceList.thousands_separator,
                    fractionCount: 2,
                    fractionSeparator: configuration.priceList.decimal_separator,
                    symbolPosition: (configuration.priceList.currency_position == "right" ? "" : "front"),
                    symbolSpacing: true
                })}}
            </td>
        </tr>
    </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import { app } from "../../application.js";

export default {
    name: "bomRowMobileComponent",
    components: { Fragment },

    props: {
        product: {
            type: Object,
            default: () => ({})
        },
        configuration: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            app: app,
            randomId: Math.random()
                .toString(36)
                .replace(/[^a-z]+/g, "")
                .substr(2, 10)
        };
    }
};
</script>




